import { StudioState } from '../../types/store';
import { initializeDiscounts } from '../../actions/studio/discounts';

export const handleInitializeDiscounts = (
  state: StudioState,
  action: ReturnType<typeof initializeDiscounts>
): StudioState => ({
  ...state,
  discounts: {
    subsection: action.payload.subsection,
    limitations: action.payload.limitations,
  },
});
